import React from 'react';

import { SxProps, Theme } from '@mui/material';

import QuillEditor, { QuillEditorProps } from 'src/components/QuillEditor';
import { BaseProps } from 'src/components/types';

import { ReactQuillProps } from '../QuillEditor/useQuillEditorModules';

type EditorProps = BaseProps & {
  sx?: SxProps<Theme>;
  height?: number;
  readOnly?: boolean;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;

  // Quill editor specific props
  quillRef?: QuillEditorProps['quillRef'];
  modules?: ReactQuillProps['modules'];
};

const Editor = ({
  dataTestId,
  sx,
  height,
  readOnly,
  quillRef,
  value,
  defaultValue,
  modules,
  placeholder,
  onChange,
  onBlur,
}: EditorProps) => {
  return (
    <QuillEditor
      dataTestId={dataTestId}
      defaultValue={defaultValue}
      sx={sx}
      editorHeight={height}
      readOnly={readOnly}
      quillRef={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      placeholder={placeholder}
      onBlur={() => {
        if (onBlur) {
          onBlur();
        }
      }}
    />
  );
};

export default Editor;
